export default "__VITE_ASSET__DY9fqW46__"